import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { WebBillListComponent } from './web-bill-list.component';
import { DirectiveModule } from 'src/app/directive/directive.module';
import { DateAgoPipeModule } from 'src/app/pipes/date-ago.module';

@NgModule({
  imports: [
    SharedModule,
    DateAgoPipeModule,
    DirectiveModule
  ],
  declarations: [WebBillListComponent
  ],
  exports: [WebBillListComponent]
})
export class WebBillListComponentModule {}
